import { render, staticRenderFns } from "./GroupCardContent.vue?vue&type=template&id=fb19a1b6&scoped=true"
import script from "./GroupCardContent.vue?vue&type=script&lang=js"
export * from "./GroupCardContent.vue?vue&type=script&lang=js"
import style0 from "./GroupCardContent.vue?vue&type=style&index=0&id=fb19a1b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb19a1b6",
  null
  
)

export default component.exports